import React from 'react';
import PageTemplate from '../components/Layout/PageTemplate/PageTemplate';
import CommonList from '../views/CommonTableView';
const OrganisationPage = () => {
    return (
        <PageTemplate>
           <CommonList page={"organisation"}/>
        </PageTemplate>
    );
};

export default OrganisationPage;

